const projectsData = [
  {
    name: "IrisLens Photography",
    desc: `IrisLens is a Photography website owned by David Aderogba, dedicated to helping 
        you keep memories in the most perfect and splendiferous way. They care about people and 
        their happiness, and they in every way possible give them the best of their services.`,
    type: "Frontend Web",
    typeIcon: "icon-globe",
    technology: "React.Js",
    techIcon: "icon-genius",
    url: "https://irislens.netlify.com/",
    image: ["/images/irisLens.jpg"],
    link: "https://github.com/Emmaccen/iris",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Dumont Hotel",
    desc: `Dumont Hotel is a Hotel website, It's a website that gives a user the overview of how
     the hotel looks like. One can view the gym, rooms and other features the hotel has.
     This project is a joint project.
    `,
    type: "Frontend Web",
    typeIcon: "icon-globe",
    technology: "Html, Css & Js",
    techIcon: "icon-genius",
    url: "https://hngi.github.io/fury-frontend/",
    image: ["/images/project1.png"],
    link: "https://github.com/adekniyi/frontend/tree/Group4",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Bevily Foods",
    desc: `'Bevily Foods' is a food company that offers commercial food services to people ranging from online 
        food ordering to table bookings and many more. Its a side project i came up with, and this online store is 
        purely fictious and non-existent. I love playing around with designs and applications.`,
    type: "Frontend Web",
    typeIcon: "icon-globe",
    technology: "React.Js",
    techIcon: "icon-genius",
    url: "https://bevily.netlify.app/",
    image: ["/images/bevilyFoods.jpg"],
    link: "https://github.com/Emmaccen/bevy",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Testmi Frontend",
    desc: `Testmi is a school management platform that helps student take class online`,
    type: "Fullstack Web",
    typeIcon: "icon-globe",
    technology: "React.Js and .Net Api",
    techIcon: "icon-genius",
    url: "https://testmi.netlify.app/",
    image: ["/images/testmifront.png"],
    link: "https://github.com/devquomodo/TestMiBackend",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Testmi Backend",
    desc: `Testmi is a school management platform that helps student take classes online`,
    type: "Backend Web",
    typeIcon: "icon-globe",
    technology: ".Net Api",
    techIcon: "icon-genius",
    url: "https://testmibackendapi.azurewebsites.net/swagger/index.html",
    image: ["/images/testmi.png"],
    link: "https://github.com/devquomodo/TestMiBackend",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Vestar Coffee Api",
    desc: `VEstar coffee Api is the api for a an ecommerce web app where one can order coffe and keep track of all orders`,
    type: "Backend Web",
    typeIcon: "icon-globe",
    technology: ".Net Api",
    techIcon: "icon-genius",
    url: "https://vestarcoffeeappapi.azurewebsites.net/swagger/index.html",
    image: ["/images/vestarcoffeeApi.png"],
    link: "https://github.com/Emmaccen/OnlineStoreBackend",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Vestar Coffee Frontend",
    desc: `Vestar coffee an ecommerce web app where one can order coffe and keep track of all orders`,
    type: "Fullstack Web",
    typeIcon: "icon-globe",
    technology: "React.js and .Net Api",
    techIcon: "icon-genius",
    url: "https://bevy-store.netlify.app/admin/dashboard",
    image: ["/images/vestarcoffee.png"],
    link: "https://github.com/Emmaccen/Online-Store",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "SiwesApp Backend",
    desc: `SiwesApp is a web application that help keep track of a student IT process`,
    type: "Backend Web",
    typeIcon: "icon-globe",
    technology: ".Net Api",
    techIcon: "icon-genius",
    url: "https://github.com/adekniyi/SiwesApp",
    image: ["/images/SiwesApp.png"],
    link: "https://github.com/adekniyi/SiwesApp",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "BeachSite",
    desc: `BeachSite is a web application where one can post the beach one have visited and also see other beaches where other people have visited`,
    type: "Fullstack Web",
    typeIcon: "icon-globe",
    technology: ".Net MVC",
    techIcon: "icon-genius",
    url: "https://github.com/adekniyi/Beach",
    image: ["/images/beachapp.png"],
    link: "https://github.com/adekniyi/Beach",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "VidlyApp",
    desc: `Simple CRUD operations`,
    type: "Fullstack Web",
    typeIcon: "icon-globe",
    technology: ".Net MVC",
    techIcon: "icon-genius",
    url: "https://github.com/adekniyi/vidly-mvc",
    image: ["/images/vidly.png"],
    link: "https://github.com/adekniyi/vidly-mvc",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Shoe Ecommerce website",
    desc: `This website is an ecommerce website where one can shop for different types of shoes.
    the website is still on going althouh all the functionality is done
    `,
    type: "Frontend Web",
    typeIcon: "icon-globe",
    technology: "React,js",
    techIcon: "icon-html-five2",
    url: "https://ecomerce-shoe-website.vercel.app/",
    image: ["/images/project2.png"],
    link: "https://github.com/adekniyi/Ecomerce-Shoe-Website",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Github Api ",
    desc: `Github has an api use to get the name,repo,location and so on of it's users.
    This project uses Github api to get all of these.
    `,
    type: "Frontend Web",
    typeIcon: "icon-globe",
    technology: "React,js",
    techIcon: "icon-html-five2",
    url: "https://raect-github-api.vercel.app/",
    image: ["/images/project4.png"],
    link: "https://github.com/adekniyi/raect-github-api",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Voting App backend",
    desc: `This web app was used by over 360 students in voting for their candidate`,
    type: "Backend Web",
    typeIcon: "icon-globe",
    technology: ".Net",
    techIcon: "icon-genius",
    url: "https://e-votingapp.azurewebsites.net/swagger/index.html",
    image: ["/images/votingb.png"],
    link: "https://github.com/adekniyi/E-voting",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  },
  {
    name: "Voting App",
    desc: `This web app was used by over 360 students in voting for their candidate`,
    type: "Fullstack Web",
    typeIcon: "icon-globe",
    technology: "React",
    techIcon: "icon-genius",
    url: "https://pans-e-voting-web-app.vercel.app/",
    image: ["/images/voting.png"],
    link: "https://github.com/lolyparty/PANS-E-VOTING-WEB-APP",
    linkHover: "Git Repo",
    linkIcon: "icon-git",
  }
];

export default projectsData;
